export default __webpack_public_path__ + "static/media/statistika-detail.c91fbeba.PNG";